module.exports = __webpack_public_path__ + "5b38cadc5aa708e51070a39bdfeb9d07.png";